import React from 'react';
import styled from 'styled-components';
import { InformationNotifications } from '@hotelplan/components.common.notifications';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import { useGetNotificationsQuery } from 'graphql/notifications/GetNotifications.generated';

const InformationNotificationsWrapper = styled.div(() =>
  sx2CssThemeFn({
    width: '100%',
    mx: 'auto',
  })
);

const InformationNotificationsBanner = () => {
  const { data } = useGetNotificationsQuery();

  return (
    <InformationNotificationsWrapper>
      <InformationNotifications
        notificationData={data?.notificationData}
        solidBg
        className="inform-notification"
      />
    </InformationNotificationsWrapper>
  );
};

export default InformationNotificationsBanner;
